import { reactive } from "vue";

/**
 * État global pour afficher la modale "session expirée".
 * Utilisé par le router et App.vue.
 */
export const tokenExpiredState = reactive({
  show: false,
});

/**
 * Décode le payload d'un JWT (sans vérifier la signature).
 * @param {string} token - JWT (access token)
 * @returns {object|null} Payload décodé ou null si invalide
 */
function decodeJwtPayload(token) {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const json = atob(base64);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/**
 * Vérifie si l'access token est expiré (exp en secondes).
 * Considère expiré si exp <= now (avec marge optionnelle de 30 s).
 * @param {string} token - Access token JWT depuis localStorage
 * @param {number} marginSeconds - Marge en secondes avant exp pour considérer expiré (défaut 30)
 * @returns {boolean} true si expiré ou token invalide
 */
export function isAccessTokenExpired(token, marginSeconds = 30) {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== "number") return true;
  const nowSeconds = Math.floor(Date.now() / 1000);
  return payload.exp <= nowSeconds + marginSeconds;
}
